import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from './cn.js';
/** Schmaler Fortschrittsbalken, value 0..1. */
export function Progress({ value, className, tone = 'amber', }) {
    const pct = Math.max(0, Math.min(1, value)) * 100;
    return (_jsx("div", { className: cn('h-1.5 w-full overflow-hidden rounded-full bg-stone-800', className), role: "progressbar", "aria-valuenow": pct, children: _jsx("div", { className: cn('h-full transition-[width]', tone === 'amber' ? 'bg-amber-500' : 'bg-sky-500'), style: { width: `${pct}%` } }) }));
}
//# sourceMappingURL=progress.js.map